"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Banner = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("../");
var Banner = function (_a) {
    var primaryActionName = _a.primaryActionName, secondaryActionName = _a.secondaryActionName, children = _a.children, className = _a.className, onPrimaryActionClick = _a.onPrimaryActionClick, onSecondaryActionClick = _a.onSecondaryActionClick, onClose = _a.onClose, icon = _a.icon, _b = _a.status, status = _b === void 0 ? 'info' : _b, title = _a.title, props = __rest(_a, ["primaryActionName", "secondaryActionName", "children", "className", "onPrimaryActionClick", "onSecondaryActionClick", "onClose", "icon", "status", "title"]);
    var getIconType = function () {
        switch (status) {
            case 'critical':
                return 'warning';
            case 'warning':
                return 'warning';
            case 'success':
                return 'check_circle';
            default:
                return 'info';
        }
    };
    var hasPrimaryAction = function () {
        return !!(primaryActionName && onPrimaryActionClick);
    };
    var hasSecondaryAction = function () {
        return !!(secondaryActionName && onSecondaryActionClick);
    };
    var BannerClasses = classnames_1.default('Banner', className, {
        'Banner--critical': status === 'critical',
        'Banner--warning': status === 'warning',
        'Banner--success': status === 'success',
        'Banner--info': status === 'info',
        'Banner--compact': children === undefined,
    });
    return (react_1.default.createElement("div", __assign({ className: BannerClasses }, props),
        icon && react_1.default.createElement(__1.Icon, { className: "Banner__icon", name: getIconType() }),
        react_1.default.createElement("div", { className: "Banner__body" },
            react_1.default.createElement("div", { className: "Banner__text" },
                react_1.default.createElement("div", { className: "Banner__title" }, title),
                children),
            (primaryActionName || secondaryActionName) && (react_1.default.createElement("div", { className: "Banner__action" },
                hasPrimaryAction() && (react_1.default.createElement(__1.Button, { outline: true, small: true, onClick: onPrimaryActionClick }, primaryActionName)),
                hasSecondaryAction() && (react_1.default.createElement(__1.Button, { fill: "subtle", small: true, onClick: onSecondaryActionClick }, secondaryActionName))))),
        onClose && (react_1.default.createElement(__1.Icon, { className: "Banner__close", onClick: onClose, name: "clear" }))));
};
exports.Banner = Banner;
//# sourceMappingURL=Banner.js.map